import { startOfToday } from "date-fns/startOfToday";
import { endOfToday } from "date-fns/endOfToday";
import { endOfTomorrow } from "date-fns/endOfTomorrow";
import { endOfWeek } from "date-fns/endOfWeek";

import { getDay, isAfter } from "date-fns";

export const isBeforeFriday = () => getDay(new Date()) < 5;

type TaskLike = {
  due_date?: string | null;
  done_date?: string | null;
};

export const isDone = (task: TaskLike) => task.done_date != null;

export const isRecentlyDone = (task: TaskLike) =>
  task.done_date != null &&
  isAfter(new Date(task.done_date), new Date(Date.now() - 5 * 60 * 1000));

export const isOverdue = (dateString?: string | null) => {
  if (!dateString) {
    return false;
  }

  return new Date(dateString) < startOfToday();
};

export const isDueToday = (dateString?: string | null) => {
  if (!dateString) {
    return false;
  }

  const dueDate = new Date(dateString);

  return dueDate >= startOfToday() && dueDate < endOfToday();
};

export const isDueTomorrow = (dateString?: string | null) => {
  if (!dateString) {
    return false;
  }

  const dueDate = new Date(dateString);

  return dueDate >= endOfToday() && dueDate < endOfTomorrow();
};

export const isDueThisWeek = (dateString?: string | null) => {
  if (!dateString) {
    return false;
  }

  const dueDate = new Date(dateString);

  return (
    dueDate >= endOfTomorrow() &&
    dueDate <
      endOfWeek(new Date(), {
        weekStartsOn: 0,
      })
  );
};

export const isDueLater = (dateString?: string | null) => {
  if (!dateString) {
    return false;
  }

  const dueDate = new Date(dateString);

  return (
    dueDate >=
    endOfWeek(new Date(), {
      weekStartsOn: 0,
    })
  );
};
